import axios from "axios"
import { getRequestConfig } from "../../auth/auth"
import { ApiGateway } from "../../config/config"
import { useCallback, useEffect, useState } from "react"
import { Card, CardContent, CardHeader, Typography } from "@mui/material"
import { Link, useNavigate } from "react-router-dom"
import { LoadingButton } from "@mui/lab"
import { Stack } from "@mui/system"

function MiniStatBox(props) {

  const getValue = () => {
    return props.value.replace ? props.value.replace(/%/g, '') : props.value;
  }

  const isPercentage = () => {
    return props.value.indexOf ? (props.value.indexOf('%') > -1) : false;
  }

  const getClassName = () => {
    var className = 'mini-stat-box ';
    if(props.theme) {
      className += props.theme;
    } else {
      if(isPercentage()) {
        const value = getValue();
        if(value > 90) {
          className += 'bg-green';
        } else if (value >= 80) {
          className += 'bg-aqua';
        } else if (value >= 70) {
          className += 'bg-yellow';
        } else {
          className += 'bg-red';
        }
      } else {
        className += 'bg-gray';
      }
    }

    return className;
  }

  let percent = isPercentage() ? <sup>%</sup> : '';

  return (
    <div className={getClassName()}>
      {/* <div className="reflection"></div> */}

      {props.children ? props.children : <h3>{getValue()}{percent}</h3>}
    </div>
  )
}

export default function FitnessIndexCard(props = { manufacturer: undefined, fitnessIndexId: undefined}) {
  const { manufacturer, fitnessIndexId } = props
  const [fitnessIndex, setFitnessIndex] = useState(null)
  const [noIndex, setNoIndex] = useState(null)
  const [creatingIndex, setCreatingIndex] = useState(null)
  const navigate = useNavigate()

  const getFitnessIndex = useCallback(async() => {
    if (!manufacturer?.manufacturerId && fitnessIndexId === undefined) return

    
    const requestConfig = await getRequestConfig()
    let basePath, response
    let search
    if (fitnessIndexId !== undefined) {
      search = { id: fitnessIndexId } 
    } else {
      search = { manufacturerId: manufacturer.manufacturerId }
    }

    basePath = `${ApiGateway.fitnessIndexes}/search`
    response = await axios.post(basePath, search, requestConfig)
    const { data: result } = response.data
    
    setFitnessIndex(result?.[0])
    if (!result?.[0]) {
      setNoIndex(true)
    }
  }, [fitnessIndexId, manufacturer?.manufacturerId])

  const createFitnessIndex = async() => {
    if (!manufacturer?.manufacturerId) return
    setCreatingIndex(true)
    const requestConfig = await getRequestConfig()
    const basePath = `${ApiGateway.fitnessIndexes}/create`
    const body = { manufacturerId: manufacturer.manufacturerId }

    try {
      const response = await axios.post(basePath, body, requestConfig)
      const { result } = response.data
      
      if (result?.data?.insertId) {
        navigate(`/fitness-indexes/${result.data.insertId}`)
      }
    } catch (error) {

    } finally {
      setCreatingIndex(false)
    }
  }

  useEffect(() => {
    getFitnessIndex()
  }, [getFitnessIndex])
  return (
    <>
    { (fitnessIndex || noIndex) && 
      <Card sx={{marginTop: '5px'}} variant="outlined" style={{textAlign: 'center'}}>
        <CardHeader title="Fitness Index Score" titleTypographyProps={{ fontSize: '1em !important', fontWeight: 'bold', color: 'text.secondary', variant: 'body2'}}></CardHeader>
        <CardContent >
        { noIndex && manufacturer && 
          <Stack spacing={1}>
            <Typography variant="body2">No index found for this facility</Typography>
            <LoadingButton variant="outlined" loading={creatingIndex} onClick={createFitnessIndex}>Create Index</LoadingButton>
          </Stack>
        }
        { fitnessIndex &&
          <Link to={`/fitness-indexes/${fitnessIndex.fitnessIndexId}`}>
            <Typography variant="body2">Last Updated {new Date(fitnessIndex.modifiedOn).toLocaleDateString()}</Typography>
            <MiniStatBox value={`${Number(fitnessIndex.totalScore).toFixed(2)}%`} />
          </Link>
        }
        </CardContent>
      </Card>
    }
    </>
  )

}